import {
  BrandMetaVariant,
  getBrandMeta,
} from "@features/PricingProject/lib/getBrandMeta";
import classNames from "classnames";
import styles from "./styles.module.scss";

export type CampaignProjectIdentityVariant = "page" | "list";

interface CampaignProjectIdentityProps {
  brand: string;
  campaignTitle: string;
  variant?: CampaignProjectIdentityVariant;
  className?: string;
  logo?: string;
}

const variantClassMap: Record<BrandMetaVariant, string> = {
  amber: styles.brandLogoAmber,
  violet: styles.brandLogoViolet,
  green: styles.brandLogoGreen,
  sky: styles.brandLogoSky,
  slate: styles.brandLogoSlate,
};

export function CampaignProjectIdentity({
  brand,
  campaignTitle,
  variant = "page",
  className,
  logo,
}: CampaignProjectIdentityProps) {
  const meta = getBrandMeta(brand);
  const logoSizeClass =
    variant === "page" ? styles.brandLogoLg : styles.brandLogoMd;

  return (
    <div className={classNames(styles.identity, className)}>
      {logo ? (
        <span
          className={classNames(styles.brandLogo, logoSizeClass, styles.brandLogoImageWrap)}
          aria-hidden
        >
          <img src={logo} alt={brand} className={styles.brandLogoImg} />
        </span>
      ) : (
        <span
          className={classNames(
            styles.brandLogo,
            logoSizeClass,
            variantClassMap[meta.variant]
          )}
          aria-hidden
        >
          {meta.initials}
        </span>
      )}
      <div className={styles.textBlock}>
        <p className={styles.brandName}>{brand}</p>
        <h1
          className={classNames(styles.campaignTitle, {
            [styles.campaignTitleSm]: variant === "list",
          })}
        >
          {campaignTitle}
        </h1>
      </div>
    </div>
  );
}
